<script lang="ts" module>
  import type { AnyConfigurationOption } from '@/teoCore/config/config-setup.types';
  import type { DropdownCategoryGrouped } from '@/teoCore/text/GeneratorUiHandler.helpers';
  import InputButton from '@/ui/elements/buttons/InputButton.svelte';
  import DropDown from '@/ui/elements/dropdown/DropDown.svelte';

  export interface ConfigCardProps<TOption extends AnyConfigurationOption> {
    title: string;
    description?: string;
    options?: TOption[];
    groups?: DropdownCategoryGrouped['groups'];
    value?: TOption['id'] | false | null | undefined;
    onchange?: (value: TOption['id']) => void;
    groupName: string;
  }
</script>

<script lang="ts" generics="TOption extends AnyConfigurationOption">
  let {
    title,
    description,
    groups,
    options,
    value: currentValue,
    onchange,
    groupName,
    ...rest
  }: ConfigCardProps<TOption> = $props();

  let handleChange = (value: TOption['id'], selected: boolean) => {
    if (selected) {
      onchange?.(value);
    }
  };
</script>

<div {...rest} class="fc gap-3 rounded-md bg-prim p-3">
  <div class="fc gap-1">
    <h2 class="text-sm font-medium">{title}</h2>
    {#if description}
      <p class="text-xs">{description}</p>
    {/if}
  </div>
  <div class="fr flex-wrap gap-2">
    {#if groups}
      {#each groups as group (group.name)}
        {#if group.name === '' || group.dropdown.options.length <= 1}
          {#each group.dropdown.options as option (option.value)}
            {#if option.type !== 'HIDDEN'}
              <InputButton
                name={groupName}
                label={option.label}
                value={option.value}
                checked={option.value === currentValue}
                onchange={(selected) => handleChange(option.value, selected)}
                disabled={option.type === 'INACTIVE'}
              />
            {/if}
          {/each}
        {:else}
          <DropDown
            variant="button"
            class="bg-plain"
            items={group.dropdown.options}
            selected={currentValue || undefined}
            onItemClick={(value) => handleChange(value, true)}
            ariaLabel={group.name}
            placeholder={group.name}
            withCheckbox
          />
        {/if}
      {/each}
    {/if}
    {#if !groups && options}
      {#each options as option (option.id)}
        {#if option.type !== 'HIDDEN'}
          <InputButton
            name={groupName}
            label={option.label}
            value={option.id}
            checked={option.id === currentValue}
            onchange={(selected) => handleChange(option.id, selected)}
            disabled={option.type === 'INACTIVE'}
          />
        {/if}
      {/each}
    {/if}
  </div>
</div>
